export default __webpack_public_path__ + "static/media/480_dummy2016-ferienwohnung01-mobile-de.83d0f6ce.png";